import {createContext, ReactNode, useContext} from 'react'

/**
 * The Money Manager's Main Offer choice and how to change it (PT-6881).
 *
 * Only the master view carries one. The agent view gets none, so an agent never sees a control
 * for a choice that belongs to the manager.
 */
export type MainOfferControl = {
  /** The stored Main Offer, or `null` when the manager has not picked one. */
  offerId: number | null
  /** True while a change is being saved; the controls are disabled meanwhile. */
  saving?: boolean
  /** Sets the Main Offer, or clears it with `null`. */
  onChange: (offerId: number | null) => void
}

const MainOfferContext = createContext<MainOfferControl | undefined>(undefined)

export const MainOfferProvider = ({
  value,
  children,
}: {
  value?: MainOfferControl
  children: ReactNode
}) => <MainOfferContext.Provider value={value}>{children}</MainOfferContext.Provider>

/** The Main Offer control of the enclosing tree, or `undefined` when the tree has none. */
export const useMainOffer = (): MainOfferControl | undefined => useContext(MainOfferContext)
